import React from "react";

const Pageloader = () => {
	return (
		<div className="flex justify-center my-auto">
			<div className="lds-ripple ">
				<div></div>
				<div></div>
			</div>
		</div>
	);
};

export default Pageloader;
